<login-form *ngIf="LoginService.activeForm === 'login'" loginMessage="Welcome!" loginType="free-practice" [captcha]="showCaptcha"></login-form>

<forgot-password *ngIf="LoginService.activeForm === 'passwordReset'"></forgot-password>
